import React, { FC, useEffect, useState } from 'react'
import { push } from 'connected-react-router'
import { matchPath, generatePath } from 'react-router-dom'

import ProjectNavigation from './Projects'
import PageNavigation from './Pages'

import { useDispatch, useSelector } from '../../store'
import { chooseProjectAction } from '../../store/project/slice'
import { logOutThunk } from '../../store/auth/thunks'
import {
  toggleAddProjectModalAction,
  toggleEditProfileModalAction,
  showApprovalListAction
} from '../../store/application/slice'

import { APPROVAL_LIST_TYPE } from '../../store/application/types';


import { TProject } from '../../store/project/types'

import './Navigation.scss'
import { AUTH_ROUTE, NON_AUTH_ROUTE } from '../../pages/App/routes'
import {
  hideTransparentPreloaderAction,
  showTransparentPreloaderAction
} from '../../store/transparentPreloader/slice'
import { setUserRoleAction } from '../../store/auth/slice'
import { resetBillingStateAction } from '../../store/billing/slice';

interface NavigationProps {
  isEnablePageNavigation: boolean
}

const Navigation: FC<NavigationProps> = ({ isEnablePageNavigation }) => {
  const dispatch = useDispatch()
  const { currentProject, agency, user, location, projects } = useSelector((state) => ({
    currentProject: state.project.currentProject,
    agency: state.agency.agency,
    user: state.auth.user,
    location: state.router.location,
    projects: state.agency.projects
  }))

  const [firstProjectLoaded, setFirstProjectLoaded] = useState<boolean>(false)

  useEffect(() => {
    if (!firstProjectLoaded) {
      const currentProjectId = +location.pathname.split('/')[1]
      const currentProjectAfterLoadPage = projects.find(({ id }) => id === currentProjectId)
      if (currentProjectAfterLoadPage && currentProjectAfterLoadPage.id !== currentProject.id) {
        setFirstProjectLoaded(true)
        dispatch(setUserRoleAction(currentProjectAfterLoadPage.role))
        dispatch(chooseProjectAction(currentProjectAfterLoadPage))
      }
    }

    return () => {
      if (!firstProjectLoaded) {
        setFirstProjectLoaded(false)
      }
    }

  }, [projects])

  const generatePathToPage = (path: string) => {
    return generatePath(path, {
      projectId: currentProject.id
    })
  }

  const isActiveRoute = (path: string) => {
    return matchPath(location.pathname, {
      path: path
    })
  }

  const moveTo = (path: string) => dispatch(push(generatePathToPage(path)))

  const signOut = async () => {
    dispatch(showTransparentPreloaderAction())
    await dispatch(logOutThunk())
    dispatch(push(NON_AUTH_ROUTE.LOGIN))
    dispatch(hideTransparentPreloaderAction())
    dispatch(resetBillingStateAction())
  }

  const billing = ()=>{
    dispatch(push('/billing'))
  }

  const openAddProjectModal = () => {
    dispatch(toggleAddProjectModalAction())
  }

  const openEditProfileModal = () => {
    dispatch(toggleEditProfileModalAction())
  }

  const navigationProps = {
    isActiveRoute,
    moveTo,
    location,
    currentProject
  }

  //
  const changeProject = (project: TProject) => {
    dispatch(setUserRoleAction(project.role))
    dispatch(chooseProjectAction(project))
    dispatch(showApprovalListAction(APPROVAL_LIST_TYPE.PENDING))
    dispatch(
      push(
        generatePath(AUTH_ROUTE.CALENDAR, {
          projectId: project.id
        })
      )
    )
  }
  return (
    <div className='navigation'>
      <ProjectNavigation
        user={user}
        projects={projects}
        agency={agency}
        changeProject={changeProject}
        signout={signOut}
        billing = {billing}
        openEditProfileModal={openEditProfileModal}
        openAddProjectModal={openAddProjectModal}
        {...navigationProps}
      />
      {isEnablePageNavigation && <PageNavigation {...navigationProps} />}
    </div>
  )
}

export default Navigation
